import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActionSheetController, NavController, ToastController } from '@ionic/angular';
import { ProfileService } from 'src/app/services/profile.service';
import { ListCustomerBank } from '../../interfaces/api/customer_bank';
@Component({
  selector: 'app-payment-card',
  templateUrl: './payment-card.component.html',
  styleUrls: ['./payment-card.component.scss'],
})
export class PaymentCardComponent implements OnInit {
  @Input() detailCustomerBank: ListCustomerBank;
  @Output() reloadList = new EventEmitter<void>();
  bankNumMode: 'show' | 'hidden' = 'hidden';

  constructor(
    private profileService: ProfileService,
    private toastController: ToastController,
    private navController: NavController,
    private actionSheetCtrl: ActionSheetController,
  ) {}

  toggleBankNumMode() {
    if (this.bankNumMode === 'hidden') {
      this.bankNumMode = 'show';
    } else {
      this.bankNumMode = 'hidden';
    }
  }

  goToUpdateCustomerBank() {
    this.navController.navigateForward(['/add-customer-bank', { customerBankID: this.detailCustomerBank.id }]);
  }

  updateToActive() {
    this.profileService.updateCustomerBankToActive(this.detailCustomerBank.id).subscribe({
      next: async (val: any) => {
        this.reloadList.emit();
        this.presentToast(val.message);
      },
      error: err => {},
    });
  }

  deleteCustomerBank() {
    this.profileService.deleteCustomerBank(this.detailCustomerBank.id).subscribe({
      next: async (val: any) => {
        this.reloadList.emit();
        this.presentToast(val.message);
      },
      error: err => {},
    });
  }

  ngOnInit() {}

  getImageLink(bankName: string): string {
    let bankImgUrl = '';

    if (bankName.includes('bca')) {
      bankImgUrl = 'bca';
    } else if (bankName.includes('bni')) {
      bankImgUrl = 'bni';
    } else if (bankName.includes('bri')) {
      bankImgUrl = 'bri';
    } else if (bankName.includes('bsi')) {
      bankImgUrl = 'bsi';
    } else if (bankName.includes('btn')) {
      bankImgUrl = 'btn';
    } else if (bankName.includes('cimb')) {
      bankImgUrl = 'cimb';
    } else if (bankName.includes('danamon')) {
      bankImgUrl = 'danamon';
    } else if (bankName.includes('mandiri')) {
      bankImgUrl = 'mandiri';
    } else if (bankName.includes('ocbc')) {
      bankImgUrl = 'ocbc';
    } else {
      bankImgUrl = 'bank-default';
    }

    return `../../../assets/images/${bankImgUrl}.png`;
  }

  async onPresentActionSheet() {
    const actionSheet = await this.actionSheetCtrl.create({
      header: 'Pilihan lainnya',
      buttons: [
        {
          text: 'Pilih sebagai default',
          handler: () => this.updateToActive(),
        },
        {
          text: 'Hapus rekening',
          role: 'destructive',
          handler: () => this.deleteCustomerBank(),
        },
        {
          text: 'Cancel',
          role: 'cancel',
          data: {
            action: 'cancel',
          },
        },
      ],
    });

    await actionSheet.present();
  }

  protected async presentToast(message: string, duration: number = 1000): Promise<void> {
    const toast = await this.toastController.create({
      message,
      duration,
      mode: 'ios',
    });
    return await toast.present();
  }
}
